import { Dictionary, TableRecord } from '@common/types';

export const isRecordDraggable = (record: TableRecord | undefined) => record?.dictionary === Dictionary.Waypoint;
